<!-- page title -->
<h1>Event Management</h1>

<ng-container *ngIf="viewModel$ | async as viewModel; else loading">
  <form class="actions-bar" [formGroup]="filtersForm" novalidate>
    <!-- actions bar -->
    <div class="toolbar " fxLayout="row" fxLayoutAlign="start center"  fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="start start">
      <button appAuthorizeControl="edit||eventmang" type="button" mat-raised-button color="accent"
        matTooltip="Add new record" [routerLink]="[0, 'details']" data-testid="New Event">
           <mat-icon class="">add</mat-icon> New Event
      </button>
    
      <button type="button" mat-stroked-button
         *ngIf="(viewModel.viewMode === 'TABLE' && eventsTable?.getSelectedSectionRecords()?.length > 0) || (viewModel.viewMode === 'EXPANSION' && eventsExpansion?.getSelectedSectionRecords()?.length > 0)"
        [matMenuTriggerFor]="menu" matTooltip="Actions">
        <mat-icon>more_vert</mat-icon>Actions 
      </button>
      <mat-menu #menu="matMenu" class="mat-dropdown-menu">
        <button type="button" mat-menu-item
          [matMenuTriggerFor]="Download"><mat-icon>arrow_circle_down</mat-icon>Download</button>
        <button class="align-middle" type="button" mat-menu-item
          [disabled]="(viewModel.viewMode === 'TABLE' && eventsTable?.getSelectedSectionRecords()?.length !== 1) || (viewModel.viewMode === 'EXPANSION' && eventsExpansion?.getSelectedSectionRecords()?.length !== 1)"
          (click)="exportGalleyProof()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.5 9.5C14.0417 9.5 13.6771 9.36458 13.4062 9.09375C13.1354 8.82292 13 8.45833 13 8V6.5C13 6.04167 13.1354 5.67708 13.4062 5.40625C13.6771 5.13542 14.0417 5 14.5 5H15.5C15.9583 5 16.3229 5.13542 16.5938 5.40625C16.8646 5.67708 17 6.04167 17 6.5V8C17 8.45833 16.8646 8.82292 16.5938 9.09375C16.3229 9.36458 15.9583 9.5 15.5 9.5H14.5ZM9.5 9.5C9.04167 9.5 8.67708 9.36458 8.40625 9.09375C8.13542 8.82292 8 8.45833 8 8V6.5C8 6.04167 8.13542 5.67708 8.40625 5.40625C8.67708 5.13542 9.04167 5 9.5 5H10.5C10.9583 5 11.3229 5.13542 11.5938 5.40625C11.8646 5.67708 12 6.04167 12 6.5V8C12 8.45833 11.8646 8.82292 11.5938 9.09375C11.3229 9.36458 10.9583 9.5 10.5 9.5H9.5ZM4.5 9.5C4.04167 9.5 3.67708 9.36458 3.40625 9.09375C3.13542 8.82292 3 8.45833 3 8V6.5C3 6.04167 3.13542 5.67708 3.40625 5.40625C3.67708 5.13542 4.04167 5 4.5 5H5.5C5.95833 5 6.32292 5.13542 6.59375 5.40625C6.86458 5.67708 7 6.04167 7 6.5V8C7 8.45833 6.86458 8.82292 6.59375 9.09375C6.32292 9.36458 5.95833 9.5 5.5 9.5H4.5ZM4.5 15C4.04167 15 3.67708 14.8646 3.40625 14.5938C3.13542 14.3229 3 13.9583 3 13.5V12C3 11.5417 3.13542 11.1771 3.40625 10.9062C3.67708 10.6354 4.04167 10.5 4.5 10.5H5.5C5.95833 10.5 6.32292 10.6354 6.59375 10.9062C6.86458 11.1771 7 11.5417 7 12V13.5C7 13.9583 6.86458 14.3229 6.59375 14.5938C6.32292 14.8646 5.95833 15 5.5 15H4.5ZM9.5 15C9.04167 15 8.67708 14.8646 8.40625 14.5938C8.13542 14.3229 8 13.9583 8 13.5V12C8 11.5417 8.13542 11.1771 8.40625 10.9062C8.67708 10.6354 9.04167 10.5 9.5 10.5H10.5C10.9583 10.5 11.3229 10.6354 11.5938 10.9062C11.8646 11.1771 12 11.5417 12 12V13.5C12 13.9583 11.8646 14.3229 11.5938 14.5938C11.3229 14.8646 10.9583 15 10.5 15H9.5ZM14.5 15C14.0417 15 13.6771 14.8646 13.4062 14.5938C13.1354 14.3229 13 13.9583 13 13.5V12C13 11.5417 13.1354 11.1771 13.4062 10.9062C13.6771 10.6354 14.0417 10.5 14.5 10.5H15.5C15.9583 10.5 16.3229 10.6354 16.5938 10.9062C16.8646 11.1771 17 11.5417 17 12V13.5C17 13.9583 16.8646 14.3229 16.5938 14.5938C16.3229 14.8646 15.9583 15 15.5 15H14.5Z"
              fill="black" />
          </svg>
          <span>Export Galley Proof</span>
        </button>
        <!-- <button type="button" mat-menu-item><mat-icon>file_copy</mat-icon>Copy</button> -->
        <button *ngIf="isAdmin()" appAuthorizeControl="admin" type="button" mat-menu-item
          (click)="deleteSelectedRecords()"><mat-icon>delete</mat-icon>Delete</button>
        <button type="button" mat-menu-item
          *ngIf="(viewModel.viewMode === 'TABLE' && eventsTable?.getSelectedSectionRecords()?.length > 0) || (viewModel.viewMode === 'EXPANSION' && eventsExpansion?.getSelectedSectionRecords()?.length > 0)">
          {{ viewModel.viewMode === 'TABLE' ? eventsTable?.getSelectedSectionRecords()?.length :
          eventsExpansion?.getSelectedSectionRecords()?.length}} Selected
        </button>
      </mat-menu>
      <mat-menu #Download="matMenu">
        <button mat-menu-item (click)="downloadCSV()">CSV</button>
      </mat-menu>

      <mat-form-field appearance="outline" class="mat-form-field-no-padding search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput formControlName="search" type="text" (input)="onSearch($event)" placeholder="Search Events" #searchInput
          data-testid="Search Bar" />
        <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value"
          (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>


      
      <mat-button-toggle-group #group="matButtonToggleGroup" value="table">
        <mat-button-toggle *ngIf="viewModel.viewMode === 'EXPANSION'" value="table" matTooltip="Table view" aria-label="Table view" (click)="toggleView('TABLE')">
          <mat-icon data-testid="Table View">table_view</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle *ngIf="viewModel.viewMode === 'TABLE'" value="expansion" matTooltip="List view" aria-label="List view"
                           (click)="toggleView('EXPANSION')">
          <mat-icon data-testid="View List">view_list</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle #filterToggleButton type="button" mat-stroked-button matTooltip="Show/hide filters" (click)="filterSidenav.toggle()"
                           data-testid="Filter">
          <mat-icon>filter_alt</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    
      
    </div>

    <mat-sidenav-container>
      <!--filter sidenav-->
      <mat-sidenav #filterSidenav mode="over" position="end">
        <mat-toolbar>
          Filter
          <span class="menu-spacer"></span>
          <button type="button" mat-icon-button aria-label="Close filter menu" matTooltip="Close filter menu"
            (click)="filterSidenav.toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-toolbar>
        <div style="margin: 16px">
          <div fxLayout="column">

            <mat-form-field appearance="outline">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker" formControlName="startDate"
                (dateChange)="onFilterChange($event, 'startDate')">
              <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
              <mat-error *ngIf="filtersForm.controls.startDate.hasError('required')">
                Start date is required
              </mat-error>
              <mat-error *ngIf="filtersForm.controls.startDate.hasError('matStartDateInvalid')">
                Invalid start date
              </mat-error>
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="endDatePicker" formControlName="endDate"
                (dateChange)="onFilterChange($event, 'endDate')">
              <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
              <mat-error *ngIf="filtersForm.controls.endDate.hasError('required')">
                End date is required
              </mat-error>
              <mat-error *ngIf="filtersForm.controls.endDate.hasError('matEndDateInvalid')">
                Invalid end date
              </mat-error>
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Divisions</mat-label>
              <mat-select multiple formControlName="divisions" (selectionChange)="onFilterChange($event)">
                <mat-option *ngFor="let division of viewModel.divisions" [value]="division">
                  {{division.DivisionName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Event type</mat-label>
              <mat-select formControlName="eventTypeId" (selectionChange)="onFilterChange($event)">
                <mat-option value="">All</mat-option>
                <mat-option *ngFor="let eventType of viewModel.eventTypes" [value]="eventType">
                  {{eventType.EventTypeName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-checkbox class="pr-check-box"
                          formControlName="includeExpiredEvents"
                          (change)="onShowExpiredEventsChange($event)">
              Include Expired Events
            </mat-checkbox>

          </div>
          <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
            <button type="button" mat-stroked-button matTooltip="Reset filters" (click)="resetFilters()">
              Reset
            </button>
            <button type="button" mat-raised-button matTooltip="Apply filters" color="accent"
              (click)="filterSidenav.toggle()" [disabled]="filtersForm.invalid">
              Apply
            </button>
          </div>
        </div>

      </mat-sidenav>

      <!--main content-->

      <!--filter chips -->
      <div class="filter-chips" *ngIf="viewModel.filters.length > 0" fxLayout="row">
        <mat-chip-set aria-label="Selected filters">
          <mat-chip *ngFor="let filter of viewModel.filters" (removed)="removeFilter(filter)">
            {{filter.displayText}}
              <mat-icon matChipRemove >cancel</mat-icon>
          </mat-chip>
          <button type="button" class="filter_close_btn" mat-flat-button matTooltip="Remove all filters" (click)="clearFilters()">
          Clear all
        </button>
        </mat-chip-set>
       
      </div>

      <!--table view-->
      <app-event-list-table #eventsTable *ngIf="viewModel.viewMode === 'TABLE'"></app-event-list-table>
      <!--expansion view-->
      <app-event-list-expansion-panel #eventsExpansion *ngIf="viewModel.viewMode === 'EXPANSION'"></app-event-list-expansion-panel>
    </mat-sidenav-container>

  </form>
</ng-container>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
